var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_88066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9217 0C7.12869 0 0 7.16375 0 16C0 24.8363 7.12869 32 15.9217 32C24.7147 32 31.8434 24.8363 31.8434 16C31.8434 7.16375 24.7147 0 15.9217 0Z",
    fill: "#2E1A47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6638 14.5517L24.4797 6.58984H22.8646L16.9463 13.503L12.2195 6.58984H6.76758L13.9155 17.0438L6.76758 25.3931H8.38282L14.6326 18.0925L19.6246 25.3931H25.0764L17.6634 14.5517H17.6638ZM8.9648 7.81176H11.4457L22.8653 24.2267H20.3844L8.9648 7.81176Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_88066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8434,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001X);
export default __webpack_public_path__ + "static/media/001-x.3d45a256795c499eca1c6a691c212901.svg";
export { ForwardRef as ReactComponent };